import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-weather-dialog",
  templateUrl: "weather-dialog.component.html",
  styleUrls: ["weather-dialog.component.scss"],
})
export class WeatherDialogComponent {
  type!: string;

  weatherForm = new FormGroup({
    zipCode: new FormControl("", [Validators.required]),
  });
  constructor(
    public dialogRef: MatDialogRef<WeatherDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data.options) {
      this.type = data.options.type;
      this.weatherForm.controls.zipCode.setValue(data.options.zipCode);
    }
  }

  get saveDisabled() {
    return !this.type || this.weatherForm.invalid;
  }

  save() {
    this.dialogRef.close({
      type: this.type,
      zipCode: this.weatherForm.controls.zipCode.value,
    });
  }
}
